// extracted by mini-css-extract-plugin
module.exports = {"transcribe":"transcribe___3jw4X","icon":"icon___bZUbF","title":"title___sGSuQ","disable":"disable___355vX"};